<template>
  <div class="nav-bar-wrapper">
    <router-link :to="{name: HOMEPAGE}" class="logo">pertsilis<span class="dot">.</span></router-link>

    <!-- Menu items -->
    <div class="menu-items">
      <router-link :to="{name: HOMEPAGE}" exact-active-class="active" class="item link-yellow">
        home<span class="dot">.</span>
      </router-link>
      <router-link :to="{name: PROJECTS}" exact-active-class="active" class="item link-purple">
        projects<span class="dot">.</span>
      </router-link>
      <!--      <router-link :to="{name: HOME}" active-class="active" class="item">work<span class="dot">.</span></router-link>-->
      <router-link :to="{name: ABOUT_ME}" exact-active-class="active" class="item link-red">
        about me<span class="dot">.</span>
      </router-link>
      <router-link :to="{name: CONTACT_ME}" exact-active-class="active" class="item link-blue-light">
        contact me<span class="dot">.</span>
      </router-link>
    </div>

    <!-- Menu toggle (Mobile) -->
    <img @click="$emit('toggle-mobile-menu')"
         src="../../../../assets/img/icons/ic_menu_icon.svg" class="menu-icon"
         alt="menu icon"/>
  </div>
</template>

<script>
import {ABOUT_ME, CONTACT_ME, HOMEPAGE, PROJECTS} from "@/router/modules/home";

export default {
  name: "NavigationBar",
  data: () => ({
    ABOUT_ME,
    HOMEPAGE,
    PROJECTS,
    CONTACT_ME
  }),
  emits: ['toggle-mobile-menu'],
}
</script>

<style scoped lang="scss">
@import "~@/assets/css/base.mixins";
@import "~@/assets/css/base.variables";
@import "~@/assets/css/base.fonts";
@import "~@/assets/css/base.links";

.nav-bar-wrapper {
  @include position-elevation(fixed, $top: 0, $right: 0, $left: 0, $elevation: 250);
  align-items: center;
  background-color: white;
  display: flex;
  height: var(--nav-bar-height);
  justify-content: space-between;
  padding: 0 20px;
  text-transform: uppercase;

  .logo {
    @include hover-active-pointer();
    font-size: 16px;
    font-weight: 900;
    line-height: 16px;
    user-select: none;
  }

  .dot {
    font-size: 26px;
  }
}

// Links
.menu-items {
  display: none;

  .item {
    @extend .font-roboto;
    font-size: 16px;
    font-weight: 700;
    line-height: 16px;
    opacity: 0.5;

    &:not(:last-child) {
      margin-right: 15px;
    }
  }

  .active {
    opacity: 1;
  }
}

// Mobile menu icon
.menu-icon {
  height: 16px;
  width: 25px;
}

@media screen and (min-width: $screen-sm) {

  // Links
  .menu-items {
    align-items: center;
    display: flex;

    .item {
      font-size: 16px;

      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }

  // Mobile menu icon
  .menu-icon {
    display: none;
  }
}
@media screen and (min-width: $screen-md) {

  // Links
  .menu-items {
    .item {
      &:not(:last-child) {
        margin-right: 20px;
      }
    }
  }
}
</style>
